<template>
  <div class="box">
    <a
      v-if="canEdit"
      href="#"
      class="edit"
      @click.prevent="$emit('edit', ['calendar', $event.target])"
    >
      {{ tc('booking.edit') }}
    </a>
    <div class="section-label">
      {{ tc('booking.date') }}
    </div>
    <div class="dates">
      <div
        class="start-date bold-item"
        v-html="formatDate(startDate)"
      />
      <div
        class="end-date bold-item"
        v-html="formatDate(endDate)"
      />
    </div>
    <div class="times">
      <div class="check-in">
        <div class="section-label small">
          {{ tc('booking.checkIn') }}
        </div>
        {{ tc('booking.after') }} {{ formatTime(startDate) }}
      </div>
      <div class="check-out">
        <div class="section-label small">
          {{ tc('booking.checkOut') }}
        </div>
        {{ tc('booking.before') }} {{ formatTime(endDate) }}
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { formatDateZone } from '@utils/date-helpers'

  export default {
    name: 'DatesOverview',
    props: {
      cart: {
        type: Object,
        required: true
      },
      canEdit: Boolean
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      startDate() {
        return this.cart.lines[0] && this.cart.lines[0].startDate
      },
      endDate() {
        return this.cart.lines[0] && this.cart.lines[0].endDate
      }
    },
    methods: {
      formatDate(val) {
        return `${formatDateZone(val, null, 'dddd')}<br>${formatDateZone(val, null, 'MMM. D[,] YYYY')}`
      },
      formatTime(val) {
        return formatDateZone(val, null, 'h:mm A')
      }
    }
  }
</script>
